export const TYPES = {
    CREDITS: 'credits',
    AUTOCREDITS: 'autocredits',
    MORTGAGES: 'mortgages',
};

export const SLUGS = {
    SELF_EMPLOYED: 'self-employed',
    POTREB_UP_TO_300: 'potreb-up-to-300',
    POTREB_OVER_300: 'potreb-over-300',
    POTREB_LOAN_REAL_ESTATE: 'potreb-loan-real-estate',
    POTREB_FOR_POTREB_GOALS: 'potreb-for-potreb-goals',
    CAR_LOAN_POTREB: 'car-loan-potreb',
    CAR_LOAN: 'car-loan',
    GREEN_MORTGAGE: 'green-mortgage',
    MORTGAGE_5_5: 'mortgage-5-5',
    MORTGAGE_REFINANCING: 'mortgage-refinancing',
    IT_MORTGAGE: 'it-mortgage',
    BUILDING: 'building',
    COMMERCIAL: 'commercial',
    VILLAGE: 'village',
    IT_MORTGAGE_BANK: 'it-mortgage-bank',
    MORTGAGE_EXCELLENT_STUDENT: 'mortgage-excellent-student',
    LARGE_FAMILY: 'large-family',
};
